import { BrowseRecipes } from "./BrowseRecipes";
export default BrowseRecipes;
